<template>
  <form
    class="form form--inline"
    @submit.prevent="submitForm"
  >
    <div class="form-wrap">
      <h2
        v-if="mainQuestion"
        :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
        :class="['h2', 'mt0', {mb2: !mainQuestion.subheading}]"
      >{{ mainQuestion.text }}</h2>
      <p
        class="p"
        v-if="mainQuestion"
      >{{ mainQuestion.subheading }}</p>
      <div
        v-for="question in questions"
        :key="question.id"
      >
        <div 
          v-if="question.kind === 'radio' || question.kind === 'checkbox'">
          <label
            class="form-label"
            v-if="mainQuestion.multiple_questions"
          >{{ question.text }}</label>
          <div
            
            class="form-radio"
            v-for="(choice, key) in question.choices"
            :key="key"
            @change="handleSelect(choice, $event)"
            @click="unCheck(question)"
          >
            <label class="form-label">
              <input
                type="radio"
                v-model="allAnswers[question.id]"
                :name="question.id"
                :value="choice.text"
                
              >
              <!-- {{choice}} -->
              <span>{{ choice.text }}</span>
            </label>
          </div>

          <span
            v-if="question.placeholder"
            class="p form-fieldset__foot-note"
          >{{ question.placeholder }}</span>
        </div>

        <div
          class="form-fieldset"
          v-if="question.kind === 'dropdown'"
        >
          <label
            v-if="mainQuestion.multiple_questions"
            for
            class="form-label"
            :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          >{{ question.text }}</label>
          <div class="form-field">
            <div class="form-wrap">
              <select 
                class="form-select"
                v-model="allAnswers[question.id]"
                :name="question.id"
                @change="handleSelect(question, $event)"
              >
                <option 
                  disabled
                  value=""
                />
                <option
                  v-for="choice in question.choices"
                  :value="choice.text"
                  :key="choice.id"
                >{{ choice.text }}</option>\
              </select>
              <span class="form-arrow" />
            </div>
          </div>
        </div>

        <div
          class="form-field-button"
          v-if="question.kind === 'yes_no'"
        >
          <module-button
            :emit="true"
            :value="question.yes_button_text ? true : null"
            @parentAction="handleBoolean"
            button="primary"
          >{{ question.yes_button_text ? question.yes_button_text : 'Yes' }}</module-button>
          <module-button
            :emit="true"
            :value="question.no_button_text ? false : null"
            @parentAction="handleBoolean"
            button="primary"
          >{{ question.no_button_text ? question.no_button_text : 'No' }}</module-button>
        </div>

        <div v-if="question.kind === 'number'">
          <div class="">
            <div class="form-wrap">
              <select
                class="form-select"
                :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
                v-model="allAnswers[question.id]"
                :name="question.id"
                @change="handleSelect(question, $event)"
              >
                <option 
                  disabled
                  selected
                  :value="null"
                />
                <option value="0">0</option>
                <option
                  v-for="i in 30"
                  :value="i"
                  :key="i"
                >{{ i }}</option>
              </select>
              <span class="form-arrow" />
            </div>
          </div>
        </div>

        <div v-if="question.kind === 'text'">
          <module-fieldset
            :type="question.kind"
            :id="question.id"
            :label="question.text"
            :placeholder="question.placeholder"
            v-bind="question"
            :required="question.is_required"
            :min="question.min_length"
            :max="question.max_length"
          />
        </div>
        <div v-if="question.kind === 'regex'">
          <module-fieldset
            type="text"
            :id="question.id"
            :label="question.text"
            :placeholder="question.placeholder"
            v-bind="question"
            :required="question.is_required"
            :min="question.min_length"
            :max="question.max_length"
          />
        </div>
        <div v-if="question.kind === 'text_box'">
          <module-fieldset
            type="textarea"
            :id="question.id"
            label=" "
            :placeholder="question.placeholder"
            v-bind="question"
            value=""
          />
        </div>
      </div>

      <module-button
        v-if="!hideSubmitButton"
        :disabled="disableSubmitButton || loading"
        button="primary"
        :loading="saving || loading"
      >Continue</module-button>
    </div>
  </form>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// API
import { HTTP } from 'api/http';

// Utils
import {
  saveAnswerToLocalStorage,
  getAnswerFromLocalStorage,
} from 'utils/questionnaire';

export default {
  name: 'component-questionnaire',

  // Props
  props: {
    intakeId: String,
    nextRoutePrefix: String,
    onCompleteRoute: String,
    loading: Boolean,
  },

  // Data
  data() {
    return {
      questions: [],
      allAnswers: {},
      data: {
        id: null,
        model: {},
      },
      saving: false,
      errorCount: 0,
      nextQuestionBasedOnAnswer: null,
      textFieldsLoaded: false,
    };
  },

  // Computed
  computed: {
    ...mapGetters('forms', ['getFieldModel']),
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapGetters('app', ['org']),
    
    fieldModals() {
      const value = {};

      _.forEach(this.questions, question => {
        value[question.id] = this.getFieldModel(`global|${question.id}`);
      });

      return value;
    },

    mainQuestion() {
      return _.find(this.questions, question => question.main_question);
    },

    hideSubmitButton() {
      if (!this.questions) return;

      return _.some(this.questions, ['kind', 'yes_no']);
    },

    requiredQuestions() {
      const q = [];

      if (this.questions && this.questions.length > 1) {
        _.forEach(this.questions, question => {
          if (question.is_required && !question.main_question) {
            q.push(question.id);
          }
        });

        return q;
      } else if (this.mainQuestion && this.mainQuestion.is_required) {
        return this.mainQuestion.id;
      }
    },

    disableSubmitButton() {
      if (this.allAnswers && this.requiredQuestions) {
        return (
          _.some(
            this.allAnswers,
            (answer, key) =>
              this.requiredQuestions.indexOf(key) !== -1 && !answer
          ) || false
        );
      }

      return false;
    },
  },

  watch: {
    fieldModals(fields) {
      _.forEach(fields, (value, key) => {
        if (value || value === '') {
          this.$set(this.allAnswers, key, value);
        }
      });
    },
  },

  // Methods
  methods: {
    ...mapActions('questions', ['requestSingleQuestion', 'requestNextQuestion']),
    ...mapActions('answers', ['requestUpdateAnswer']),
    ...mapActions('appointment', ['updateF2fAppointment']),
    ...mapActions('app', ['setErrorMessage', 'setErrorRedirect']),

    handleSelect(option, e) {
      if (!this.mainQuestion.multiple_questions) {
        this.data.model = {
          question: this.$route.params.id,
          answer: e.target ? e.target.value : e,
        };

        if (option && option.next_question) {
          this.nextQuestionBasedOnAnswer = option.next_question;
        }
      }
    },

    unCheck(option) {
      if (
        this.mainQuestion &&
        this.mainQuestion.multiple_questions &&
        this.mainQuestion.multiple_questions.length
      ) {
        if (this.allAnswers[option.id]) {
          this.allAnswers[option.id] = null;
        }
      }
    },

    submitForm() {
      HTTP.defaults.headers.common.Authorization = `Token ${localStorage.getItem(
        this.isAuthenticated ? 'fueledAuthToken' : 'answer_token'
      )}`;

      this.data.id = this.isAuthenticated
        ? localStorage.getItem('appointmentSelectionAnswer')
        : localStorage.getItem('singleAnswer');

      if (this.mainQuestion.kind === 'multiple_questions') {
        this.data.model.multiple_questions_response = [];
        this.data.model.question = this.mainQuestion.id;
        _.forEach(this.questions, question => {
          if (!question.main_question && this.allAnswers[question.id]) {
            this.data.model.multiple_questions_response.push({
              question: question.id,
              answer: this.allAnswers[question.id],
            });
          }
        });

        saveAnswerToLocalStorage(
          this.intakeId,
          this.$route.params.id,
          this.data.model.multiple_questions_response
        );
      } else {
        saveAnswerToLocalStorage(
          this.intakeId,
          this.$route.params.id,
          this.data.model.answer
            ? this.data.model.answer
            : this.allAnswers[this.$route.params.id]
        );
      }

      if (this.mainQuestion.kind === 'text_box') {
        this.data.model = {
          question: this.$route.params.id,
          answer: this.allAnswers[this.$route.params.id] || '',
        };
      }

      if (
        this.data.model.answer ||
        this.data.model.multiple_questions_response ||
        this.mainQuestion.kind === 'text_box' ||
        this.mainQuestion.kind === 'yes_no'
      ) {
        this.saving = true;

        this[
          this.isAuthenticated ? 'updateF2fAppointment' : 'requestUpdateAnswer'
        ](this.data)
          .then(() => {
            this.saving = false;
            this.nextQuestion();
          })
          .catch(error => {
            console.error('error', error);

            if (this.errorCount > 1) {
              this.setErrorMessage(
                'We\'re having trouble connecting<br class="hide-below-medium"> with our network right now'
              );
              this.setErrorRedirect({ link: 'logout', label: 'Try again' });
              this.$router.push({ name: 'error' });
              this.saving = false;

              return;
            }

            this.errorCount++;
            setTimeout(() => {
              this.submitForm();
            }, 3000);
          });
      } else if (
        this.allAnswers[this.$route.params.id] ||
        !this.mainQuestion.is_required
      ) {
        this.nextQuestion();
      }
    },

    handleBoolean(value) {
      if (
        (value === true || value === 'Yes ') &&
        !JSON.parse(localStorage.getItem('isSafe')) &&
        this.questions[0].show_safety_screen === true
      ) {
        localStorage.setItem(
          'safeNextQuestion',
          this.questions[0].next_question
        );
        this.$router.push({ name: 'safety-screen' });
      } else {
        this.data.model = {
          question: this.$route.params.id,
          answer: value,
        };

        this.submitForm();
      }
    },

    nextQuestion() {
      if (this.questions[0].next_question) {
        this.requestNextQuestion(this.$route.params.id)
          .then((res) => {
            res.data.id ?
              this.$router.push(
                `/${this.nextRoutePrefix}/${res.data.id}`
              )
              : this.$router.push({ name: this.onCompleteRoute });
          })
          .catch(err => (err));
      } else {
        this.$router.push({ name: this.onCompleteRoute });
      }

      this.$route.meta.messages = [];
    },
  },

  // Lifecycles
  created() {
    delete HTTP.defaults.headers.common.Authorization;

    this.requestSingleQuestion(this.$route.params.id).then(res => {
      this.$set(this.questions, 0, {
        main_question: true,
        ...res.data,
      });

      if (res.data.multiple_questions) {
        _.forEach(res.data.multiple_questions, question => {
          this.questions.push(question);
          this.$set(this.allAnswers, question.id, null);
        });

        const answers = getAnswerFromLocalStorage(this.intakeId, res.data.id);

        _.forEach(answers, value => {
          this.$set(this.allAnswers, value.question, value.answer || null);
          _.find(this.questions, ['id', value.question]).value =
            value.answer || null;
        });
      } else {
        const question = _.find(this.questions, ['id', res.data.id]);
        question.value = getAnswerFromLocalStorage(this.intakeId, res.data.id);

        if (question && question.kind === 'radio') {
          const answer = _.find(
            question.choices,
            choice =>
              choice &&
              choice.text ===
                getAnswerFromLocalStorage(this.intakeId, res.data.id)
          );
          this.nextQuestionBasedOnAnswer =
            (answer && answer.next_question) || null;
        }

        this.$set(
          this.allAnswers,
          res.data.id,
          getAnswerFromLocalStorage(this.intakeId, res.data.id)
        );
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// Questionnaire.vue?8c2ba6ee